import React from 'react';
import pt from 'prop-types';

import Modal from 'components/modal';
import ListingCriteriaList from 'components/partners/listing-criteria';
import { LISTING_CRITERIA } from 'partners/shared/listing-criteria';
import './SubmitListing.scss';

export default class SubmitListing extends React.PureComponent {
  static propTypes = {
    status: pt.oneOf(['not_listed', 'pending', 'listed', 'rejected']),
    onSubmit: pt.func,
  };

  static contextTypes = {
    closeModal: pt.func.isRequired,
  };

  state = {
    loading: false,
  };

  onClickSubmit = async () => {
    const { onSubmit } = this.props;

    if (onSubmit) {
      this.setState({ loading: true });

      const result = await onSubmit();

      this.setState({ loading: false });

      if (!result) {
        return;
      }
    }

    this.context.closeModal();
  };

  onClickCancel = () => {
    this.context.closeModal();
  };

  render() {
    const { status } = this.props;
    const { loading } = this.state;
    const isResubmission = status === 'pending';

    return (
      <Modal
        title={isResubmission ? 'Submit changes' : 'Submit profile'}
        width={760}
        className="submit-listing-modal"
        loading={loading}
        cancel={false}
        actions={[
          {
            label: 'Submit for review',
            type: 'default',
            onClick: this.onClickSubmit,
          },
          { label: 'Cancel', type: 'cancel', onClick: this.onClickCancel },
        ]}
      >
        {isResubmission ? (
          <p className="submit-listing-modal-text">
            The new changes will override your previous submission.
          </p>
        ) : (
          <>
            <p className="submit-listing-modal-text">
              Before you submit, a quick reminder of what our team checks for.
              Fixing these ahead of time means a faster review.
            </p>

            <ListingCriteriaList categories={LISTING_CRITERIA} />
          </>
        )}
      </Modal>
    );
  }
}
